/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsdeleted1Inputs */

const en_ticketsdeleted1 = /** @type {(inputs: Ticketsdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket type removed`)
};

const de_ticketsdeleted1 = /** @type {(inputs: Ticketsdeleted1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticketart entfernt`)
};

/**
* | output |
* | --- |
* | "Ticket type removed" |
*
* @param {Ticketsdeleted1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsdeleted1 = /** @type {((inputs?: Ticketsdeleted1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsdeleted1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsdeleted1(inputs)
	return de_ticketsdeleted1(inputs)
});
export { ticketsdeleted1 as "ticketsDeleted" }